import $ from 'jquery';
import {displayMessages, destroyMessages, destroyFieldHighlights, displayFieldHighlights, showErrorMessage } from 'stdjs/validation';
import * as utilities from 'stdjs/utilities';
import Translator from 'stdjs/translate-service';

// TODO add in 'transportError' callback. Switch to accepting an array of options after success?
function standardAjaxCore(method, url, data, successCallback, errorCallback, global, showMessages){
    
    if (typeof successCallback === "undefined" || typeof successCallback !== "function"){
        successCallback = function(data){};
    }
    
    if (typeof errorCallback === "undefined" || typeof errorCallback !== "function"){
        errorCallback = null;
    }
    
    if (typeof global === "undefined" || global === null){
        global = true;
    }
    
    if (typeof method === "undefined" || method === null){
        method = "POST";
    }

    if (typeof showMessages === "undefined" || showMessages === null){
        showMessages = true;
    }
    
    if (method !== "POST" && method !== "GET"){
        method = "GET";
    }
    
    var formDataUsed = utilities.formDataAvailable() && utilities.isFormData(data);
    var contentType = formDataUsed ? false : "application/x-www-form-urlencoded; charset=UTF-8";
    var processData = formDataUsed ? false : true;
    
    
    $.ajax({
        type: method,
        dataType: "json",
        url: url,
        cache: false,
        data: data,
        global: global,
        contentType: contentType,
        processData: processData,
        beforeSend: function() {
            destroyMessages();
            destroyFieldHighlights();
        },
        success: function(data) {
            processStandardAjaxResponse( data, successCallback, errorCallback, showMessages );
        },
        error: function(){
            
            var errorMessage = Translator.tr( "A transport error occurred. Please try again." );
            
            if ( errorCallback === null ){
                showErrorMessage( errorMessage );
            } else {
                data = {
                    success: false,
                    errorMessages:[errorMessage], 
                    warningMessages:[],
                    infoMessages:[],
                    errorFieldHighlights:[],
                    warningFieldHighlights:[], 
                    infoFieldHighlights: []
                }
                errorCallback(data);
            }
        }
    });
    
}

function processAjaxJavascriptVariables( data ){
    if ( typeof data[ "jsVariables" ] !== "undefined" ){
        $.each( data[ "jsVariables" ], function( index, value ) {
            window[ value.name ] = value.value;
        });
    }
}

export function processStandardAjaxResponse( data, successCallback, errorCallback, showMessages ){
    
    if (typeof successCallback === "undefined" || typeof successCallback !== "function"){
        successCallback = function(data){};
    }
    
    if (typeof errorCallback === "undefined" || typeof errorCallback !== "function"){
        errorCallback = null;
    }
    
    if (typeof showMessages === "undefined" || showMessages === null){
        showMessages = true;
    }
    
    if (data.success) {
        
        processAjaxJavascriptVariables( data );
                
        if (showMessages){
            displayMessages(data.errorMessages, data.warningMessages, data.infoMessages);
            displayFieldHighlights(data.errorFieldHighlights, data.warningFieldHighlights, data.infoFieldHighlights); 
        }        
        successCallback(data);                        

    } else {
        if (typeof(data["loggedout"]) !== undefined && data["loggedout"]) {

            location.href = notAuthUrl;

        } else {

            if (errorCallback === null){
                if (showMessages){
                    displayMessages(data.errorMessages, data.warningMessages, data.infoMessages);
                    displayFieldHighlights(data.errorFieldHighlights, data.warningFieldHighlights, data.infoFieldHighlights);
                }
            
            }
            else {
                errorCallback(data);
            }

        }  
    }

}

export function standardAjaxPost(url, data, successCallback, errorCallback, global, showMessages){
    standardAjaxCore("POST", url, data, successCallback, errorCallback, global, showMessages);  
}

export function standardAjaxGet(url, data, successCallback, errorCallback, global, showMessages){
    standardAjaxCore("GET", url, data, successCallback, errorCallback, global, showMessages);
}

export function standardAjaxErrorCallback(data, $context = null){
    displayMessages(data.errorMessages, data.warningMessages, data.infoMessages);
    displayFieldHighlights(data.errorFieldHighlights, data.warningFieldHighlights, data.infoFieldHighlights, $context);
}
